import { __rest } from "tslib";
import React, { useRef, useState, useEffect } from 'react';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { apiHolder, apis, getIn18Text } from 'api';
import { Input, Tooltip, Spin, Radio, message } from 'antd';
import Button from '@web-common/components/UI/Button';
import { EdmEmptyProductPic } from '@web-edm/components/editor/template';
import classnames from 'classnames';
import { AttachmentFileUpload } from '@web/components/Layout/Customer/components/moments/upload.ts';
import { ProductSampleModal } from '@web-edm/components/productSampleModal/productSampleModal';
import { ProductSettingModal } from '@web-edm/components/productSettingModal/productSettingModal';
import { getProductsHtml } from '@web-edm/components/editor/template';
import { edmDataTracker } from '@web-edm/tracker/tracker';
import IconCard from '@web-common/components/UI/IconCard';
import Loadable from '@loadable/component';
const Cascader = Loadable(() => import('@lingxi-common-component/sirius-ui/Cascader'));
setTimeout(() => {
    if (process.env.BUILD_ISEDM) {
        Cascader.preload();
    }
}, 8000);
import ImgPreview from '@web-common/components/UI/ImagePreview';
import style from './productImg.module.scss';
const customerApi = apiHolder.api.requireLogicalApi(apis.customerApiImpl);
const siteApi = apiHolder.api.requireLogicalApi(apis.siteApiImpl);
const productApi = apiHolder.api.requireLogicalApi(apis.mailProductImplApi);
const HOCProductImg = (Component) => {
    const ProductImg = (props) => {
        const { ref, onEditCreated, insertContentProductImgCallback, singleOrAuto = 'other' } = props, rest = __rest(props, ["ref", "onEditCreated", "insertContentProductImgCallback", "singleOrAuto"]);
        const [visibleInput, setvisibleInput] = useState(false);
        const [visibleProduct, setvisibleProduct] = useState(false);
        const [showSampleModal, setShowSampleModal] = useState(false);
        const [showSettingProductModal, setShowSettingProductModal] = useState(false);
        const [productList, setProductList] = useState([]);
        const [isSelectSite, setIsSelectSite] = useState(true);
        const [selectSite, setSelectSite] = useState(['']);
        const [cascaderOptions, setCascaderOptions] = useState([]);
        const [selectEditId, setSelectEditId] = useState('');
        const [radioValue, setRadioValue] = useState(2);
        const [inputError, setInputError] = useState(false);
        const [hasLocalProduct, setHasLocalProduct] = useState(false);
        const [createProSpin, setCreateProSpin] = useState(false);
        const editorRef = useRef();
        useEffect(() => {
            siteApi.getSiteDomainList({ isShowOuterSite: false }).then(siteList => {
                if (siteList.length > 0) {
                    if (siteList.length === 1 && siteList[0].bindDomains.length <= 1)
                        setSelectSite([siteList[0].siteId]);
                    const cascaderOptions = siteList.map((siteItem) => {
                        var _a;
                        return ({
                            value: siteItem.siteId,
                            label: siteItem.siteName,
                            children: ((_a = siteItem.bindDomains) === null || _a === void 0 ? void 0 : _a.length) > 1
                                ? siteItem.bindDomains.map(d => ({
                                    value: d,
                                    label: d,
                                }))
                                : [],
                        });
                    });
                    setCascaderOptions(cascaderOptions);
                }
            });
        }, []);
        useEffect(() => {
            if (!visibleProduct) {
                setHasLocalProduct(false);
                return;
            }
            productApi
                .getWaimaoProductList({
                keyword: '',
                page: 1,
                pageSize: 1,
            })
                .then(data => {
                if (data && data.totalCount) {
                    setHasLocalProduct(true);
                }
            });
        }, [visibleProduct]);
        const onEditCreatedPipe = (editor) => {
            onEditCreated && onEditCreated(editor);
            editorRef.current = editor;
        };
        const inputImg = e => {
            var _a;
            (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.execCommand('lxFileChangeUploadImage', e);
            setvisibleInput(false);
        };
        const createProduct = e => {
            const target = e.target;
            let files = target.files;
            if (files.length > 10) {
                message.warn('商品图片最多包含10张');
                files = [...files].slice(0, 10);
            }
            if (files.length > 0) {
                onFileSelect([...files]);
            }
        };
        const handleAddProducts = e => { };
        const handleAddProducts2 = data => {
            setProductList(list => {
                const remainL = 20 - list.length;
                let ValData = [...data];
                if (data.length > remainL) {
                    ValData = ValData.slice(0, remainL);
                }
                const datan = ValData.map((item, index) => ({
                    state: 'uploadFinish',
                    productId: item.id + index,
                    id: item.id,
                    name: item.product_name_en,
                    from: 'localList',
                    imgList: item.pictures || [{ url: EdmEmptyProductPic, filename: 'default', id: new Date().getTime() }],
                }));
                list.push(...datan);
                return [...list];
            });
            setShowSettingProductModal(false);
        };
        const onFileSelect = async (files) => {
            let urlList = [];
            const productId = selectEditId || new Date().getTime();
            setProductList(list => {
                if (selectEditId) {
                    list.forEach(item => {
                        if (item.productId === selectEditId) {
                            item.imgList = [];
                            item.state = 'load';
                        }
                    });
                }
                else {
                    list.push({ state: 'load', imgList: [], productId, name: '', from: 'create' });
                }
                return [...list];
            });
            files.forEach(file => {
                const uploader = new AttachmentFileUpload(file);
                uploader.on('uploadFinish', data => {
                    customerApi.documentGetDownloadUrl({ document_id: data.id }).then(res => {
                        console.log(res);
                        urlList.push({ url: res, filename: file.name, id: data.id });
                        if (urlList.length === files.length) {
                            setProductList(list => {
                                list.forEach(item => {
                                    if (item.productId === productId) {
                                        item.imgList = urlList;
                                        item.state = 'uploadFinish';
                                    }
                                });
                                return [...list];
                            });
                        }
                    });
                });
                uploader.startUpload();
            });
        };
        const changeName = (e, productId) => {
            const value = e.target.value;
            setProductList(list => {
                list.forEach(item => {
                    if (item.productId === productId) {
                        item.name = value;
                    }
                });
                return [...list];
            });
        };
        const productCreate = () => {
            let validate = true;
            if (!(cascaderOptions.length < 1 || (cascaderOptions.length == 1 && cascaderOptions[0].children.length < 2)) && !(selectSite === null || selectSite === void 0 ? void 0 : selectSite[0])) {
                setIsSelectSite(false);
                validate = false;
            }
            if (productList.filter(i => i.from === 'create').some(item => !item.name)) {
                setInputError(true);
                validate = false;
            }
            if (!validate) {
                return;
            }
            edmDataTracker.track('pc_markting_edm_picture_product_action', {
                action: 'confirm',
                source: singleOrAuto,
            });
            setCreateProSpin(true);
            const productListTemp = [...productList];
            const createLeng = productListTemp.filter(item => item.from === 'create').length;
            let count = 0;
            if (productListTemp.every(item => item.from !== 'create')) {
                insertContent(productListTemp.filter(i => i.id));
            }
            productListTemp.forEach(item => {
                if (item.from === 'create') {
                    const req = {
                        customized_field_value: [],
                        group: '1',
                        color: '1,2',
                        unit: '1',
                        price: '',
                        cost_price: '',
                        price_clause: '1',
                        shipping_method: '4,2',
                        packaging_unit: '1',
                        name_cn: item.name,
                        name_en: item.name,
                        pictures: JSON.stringify(item.imgList),
                        status: '1',
                    };
                    customerApi
                        .productCreate(req)
                        .then(res => {
                        console.log('productListsds', res, item);
                        item.id = res.id;
                    })
                        .finally(() => {
                        count++;
                        if (count === createLeng) {
                            insertContent(productListTemp.filter(i => i.id));
                        }
                    });
                }
            });
        };
        const insertContent = async (productListTemp) => {
            const links = await siteApi.getSiteLinks({
                siteOptAttrType: 'GEN_PRODUCT_DETAIL_LINK',
                productIds: productListTemp.map(item => item.id),
                siteId: selectSite[0],
                businessType: 'MARKETING',
                domain: selectSite[1],
            });
            const list = productListTemp.map(item => {
                var _a;
                const link = (_a = links.find(i => i.id == item.id)) === null || _a === void 0 ? void 0 : _a.link;
                return {
                    product_name_en: item.name,
                    productLink: link,
                    id: item.id,
                    pictures: item.imgList,
                };
            });
            const html = getProductsHtml(0, list, ['product_name_en'], {}, 150, selectSite[0]);
            if (editorRef.current) {
                editorRef.current.insertContent(html);
                insertContentProductImgCallback && insertContentProductImgCallback(productListTemp.some(_ => _.from === 'create'));
            }
            onCancelProduct();
            edmDataTracker.track('pc_markting_edm_picture_product_success', {
                create: productListTemp.some(_ => _.from === 'create'),
                sum: productListTemp.length,
                count: productListTemp.filter(_ => _.from === 'create').length,
                source: singleOrAuto,
            });
        };
        const productinputRef = useRef(null);
        const imgInputRef = useRef(null);
        const clickInput2 = () => {
            var _a;
            edmDataTracker.track('pc_markting_edm_picture_product_action', {
                action: 'create',
                source: singleOrAuto,
            });
            setSelectEditId('');
            (_a = productinputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        };
        const productPreview = item => {
            ImgPreview.preview({
                data: item.imgList.map(item => ({
                    downloadUrl: item.url,
                    previewUrl: item.url,
                    OriginUrl: item.url,
                    size: 480,
                })),
                startIndex: 0,
            });
        };
        const productUploadAgain = productId => {
            var _a;
            setSelectEditId(productId);
            (_a = productinputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        };
        const productDel = productId => {
            setProductList(list => list.filter(item => item.productId !== productId));
        };
        const onCancelProduct = () => {
            setvisibleProduct(false);
            setCreateProSpin(false);
            setProductList([]);
            setSelectSite(['']);
        };
        const onChangeRadio = e => {
            setRadioValue(e.target.value);
            edmDataTracker.track('pc_markting_edm_picture_select_action', {
                action: e.target.value === 1 ? 'picture' : 'product',
                source: singleOrAuto,
            });
        };
        const selectImgRadio = () => {
            var _a;
            edmDataTracker.track('pc_markting_edm_picture_select_action', {
                action: 'confirm',
                source: singleOrAuto,
            });
            if (radioValue === 1) {
                (_a = imgInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                edmDataTracker.track('pc_markting_edm_picture_select_type', {
                    type: 'picture',
                    source: singleOrAuto,
                });
                return;
            }
            edmDataTracker.track('pc_markting_edm_picture_select_type', {
                type: 'product',
                source: singleOrAuto,
            });
            edmDataTracker.track('pc_markting_edm_picture_product_show', {
                show: 'show',
                source: singleOrAuto,
            });
            setvisibleProduct(true);
            setvisibleInput(false);
            setRadioValue(2);
        };
        return (React.createElement("div", null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, productImgAction: () => {
                    setvisibleInput(true);
                    edmDataTracker.track('pc_markting_edm_picture_select_show', {
                        show: 'show',
                        source: singleOrAuto,
                    });
                }, onEditCreated: onEditCreatedPipe })),
            React.createElement(SiriusModal, { width: 620, height: 552, title: "\u8BF7\u9009\u62E9\u63D2\u5165\u56FE\u7247\u7684\u65B9\u5F0F", visible: visibleInput, getContainer: "#edm-write-root", onCancel: () => {
                    setvisibleInput(false);
                    edmDataTracker.track('pc_markting_edm_picture_select_action', {
                        action: 'cancel',
                        source: singleOrAuto,
                    });
                }, onOk: selectImgRadio },
                React.createElement("div", { className: classnames(style.imgRadio) },
                    React.createElement(Radio.Group, { onChange: onChangeRadio, value: radioValue },
                        React.createElement(Radio, { value: 1 }, "\u4EE5\u56FE\u7247\u5F62\u5F0F\u63D2\u5165"),
                        React.createElement(Radio, { value: 2 },
                            React.createElement("div", { className: classnames(style.imgRadio2) },
                                "\u4EE5\u5546\u54C1\u5F62\u5F0F\u63D2\u5165",
                                React.createElement("span", { className: classnames(style.recommendText) }, "\u63A8\u8350"))))),
                React.createElement("div", { className: classnames(style.imgRadioDesc) },
                    React.createElement("div", { className: classnames(style.imgRadioDesc2) }, "\u4EE5\u5546\u54C1\u5F62\u5F0F\u63D2\u5165\u56FE\u7247\uFF0C\u90AE\u4EF6\u5C55\u793A\u66F4\u6E05\u6670\uFF0C \u53EF\u4EE5\u8BB0\u5F55\u6536\u4EF6\u4EBA\u7684\u70B9\u51FB\u548C\u6D4F\u89C8\u884C\u4E3A\uFF0C\u66F4\u597D\u7684\u8FDB\u884C\u9488\u5BF9\u6027\u7684\u8F6C\u5316"),
                    React.createElement("video", { autoPlay: true, src: require('./img/producrImgDemo.mp4'), width: "548", height: "272" })),
                React.createElement("input", { className: classnames(style.inputPlace), ref: imgInputRef, onChange: inputImg, type: "file", accept: "image/*", multiple: true })),
            React.createElement(SiriusModal, { className: classnames(style.addProductModal), visible: visibleProduct, getContainer: "#edm-write-root", onCancel: onCancelProduct, width: 708, height: 600, title: "\u4E0A\u4F20\u5546\u54C1\u56FE\u7247\uFF0C\u8865\u5145\u5546\u54C1\u540D\u79F0\uFF0C\u5373\u53EF\u63D2\u5165\u5546\u54C1", footer: null },
                React.createElement(Spin, { spinning: createProSpin },
                    React.createElement("input", { className: classnames(style.inputPlace), ref: productinputRef, onChange: createProduct, type: "file", accept: "image/*", multiple: true }),
                    React.createElement("div", { className: classnames(style.boxBody) },
                        productList.map(item => {
                            var _a;
                            return (React.createElement("div", { key: item.productId, className: classnames(style.productItem) },
                                React.createElement("div", { className: classnames(style.boxWH, style.productBox) },
                                    item.state === 'load' ? (React.createElement(Spin, { tip: "\u4E0A\u4F20\u4E2D", className: classnames(style.uploadProductImg) },
                                        React.createElement("div", { style: { height: 150 } }))) : (React.createElement("div", null,
                                        React.createElement("img", { width: "150", height: "150", src: (_a = item.imgList[0]) === null || _a === void 0 ? void 0 : _a.url }),
                                        item.imgList.length > 1 && React.createElement("img", { className: classnames(style.multipleImgIcon), width: "28", height: "28", src: require('./img/multipleImg.png') }))),
                                    React.createElement("div", { className: classnames(style.productOperate) },
                                        React.createElement("div", { className: classnames(style.hgOpacity) }),
                                        React.createElement("div", { className: classnames(style.bgchange) },
                                            React.createElement(Tooltip, { title: "\u67E5\u770B\u56FE\u7247" },
                                                React.createElement("img", { onClick: () => {
                                                        productPreview(item);
                                                    }, src: require('./img/productPreview.png'), width: "32", height: "32" })),
                                            item.from === 'create' && (React.createElement(Tooltip, { title: "\u91CD\u65B0\u4E0A\u4F20" },
                                                React.createElement("img", { onClick: () => {
                                                        productUploadAgain(item.productId);
                                                    }, src: require('./img/productUploadAgain.png'), width: "32", height: "32" }))),
                                            React.createElement(Tooltip, { title: "\u5220\u9664\u56FE\u7247" },
                                                React.createElement("img", { onClick: () => {
                                                        productDel(item.productId);
                                                    }, src: require('./img/productDel.png'), width: "32", height: "32" }))))),
                                item.from === 'create' ? (React.createElement(Input, { placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u82F1\u6587\u540D\u79F0", className: classnames(style.nameInput, item.from === 'create' && inputError && !item.name ? style.inputErrorBor : ''), value: item.name, maxLength: 200, onChange: e => {
                                        changeName(e, item.productId);
                                    } })) : (React.createElement("span", { className: classnames(style.localProName) }, item.name))));
                        }),
                        20 > productList.length && (React.createElement("div", { className: classnames(style.boxWH, style.flexCenter), onClick: clickInput2 },
                            React.createElement(IconCard, { type: "add", width: "32", height: "32" }),
                            React.createElement("span", { className: classnames(style.marginTop13) }, "\u65B0\u5EFA\u5546\u54C1"))),
                        20 > productList.length && hasLocalProduct && (React.createElement("div", { onClick: () => {
                                setShowSettingProductModal(true);
                                edmDataTracker.track('pc_markting_edm_picture_product_action', {
                                    action: 'select',
                                    source: singleOrAuto,
                                });
                            }, className: classnames(style.boxWH, style.flexCenter) },
                            React.createElement("img", { src: require('./img/product.png'), width: "32", height: "32" }),
                            React.createElement("span", { className: classnames(style.marginTop13) }, "\u4ECE\u672C\u5730\u5546\u54C1\u4E2D\u9009\u62E9")))),
                    React.createElement("div", { className: classnames(style.footer) },
                        cascaderOptions.length > 0 && (React.createElement("div", null,
                            "\u6240\u5C5E\u7AD9\u70B9\uFF1A",
                            React.createElement(Cascader, { placeholder: getIn18Text('QINGXUANZE'), style: { width: 140 }, className: `${isSelectSite ? '' : style.siteCascaderError}`, popupClassName: style.siteCascader, options: cascaderOptions, changeOnSelect: true, value: selectSite[0] === '' ? undefined : selectSite, onChange: (value) => {
                                    setSelectSite(value);
                                    setIsSelectSite(true);
                                } }))),
                        React.createElement("div", { className: classnames(style.footerBtn) },
                            React.createElement(Button, { btnType: "minorLine", onClick: () => {
                                    setShowSampleModal(true);
                                    edmDataTracker.track('pc_markting_edm_picture_product_action', {
                                        action: 'sample',
                                        source: singleOrAuto,
                                    });
                                } }, "\u67E5\u770B\u793A\u4F8B"),
                            React.createElement(Button, { btnType: "primary", disabled: !productList.length, onClick: productCreate }, "\u63D2\u5165\u4EA7\u54C1"))))),
            React.createElement(ProductSampleModal, { fromPage: "ONLYIMG", visible: showSampleModal, onClose: () => setShowSampleModal(false) }),
            React.createElement(ProductSettingModal, { fromPage: "BUTTON", getContainer: "#edm-write-root", onShow: () => setShowSettingProductModal(true), onAdd: handleAddProducts, onNextStepResetdata: handleAddProducts2, visible: showSettingProductModal, onClose: () => setShowSettingProductModal(false) })));
    };
    return React.forwardRef((props, ref) => {
        var _a;
        return ((_a = props.init) === null || _a === void 0 ? void 0 : _a.productImg) ? React.createElement(ProductImg, Object.assign({}, props, { ref: ref })) : React.createElement(Component, Object.assign({}, props, { ref: ref }));
    });
};
export default HOCProductImg;
